// Business rules of the category modules that the phone and the server must compute identically (Guide §10.7).
import { D, type Decimal } from '../money';

/** What a mobile-banking transaction does to the wallet's e-money float: cash-out brings e-money IN, cash-in / send / payment take it OUT. */
export const walletDelta = (type: string, amount: Decimal.Value): Decimal => (type === 'cash_out' ? D(amount) : D(amount).negated());

/** Money-account effect of a personal-space loan: lending takes cash out, borrowing brings it in; repayments are the mirror image. */
export const loanDelta = (direction: string, amount: Decimal.Value, repayment = false): Decimal => {
  const lent = direction === 'lent';
  return D(amount).times(lent !== repayment ? -1 : 1);
};

/** Commission a wallet would earn: rate is per ৳1,000, rounded to the paisa. */
export const commissionFor = (amount: Decimal.Value, ratePerThousand: Decimal.Value): Decimal => D(amount).times(ratePerThousand).dividedBy(1000).toDecimalPlaces(2);
